import {getStatus} from '@api/status'

export const StatusMixin = {
  data(){
    return {
      status : {},
      xstatus : {},
      config : {},
      customConfig : {},
      checkResult: false,
    }
  },
  created() {

  },
  methods:{
    queryStatus() {
      getStatus(this.sectionId,this.checkId,{}).then((res) => {
        if (res.success) {
          this.status = res.result
          this.checkStatus();
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    checkStatus() {
      for (var key in this.status.prepose) {
        if (this.status.prepose[key].value != "1") {
          this.$message.error(this.status.prepose[key].message);
          return
        }
      }
      this.checkResult = true
      this.xstatus = this.status.status
      this.config = this.status.config
      this.customConfig = this.status.customConfig
    }
  }
}